import { CommonModule } from '@angular/common';
import { Component, Inject, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ConversationDerivacionPopupData } from '../../models/derivacion.model';
import { WhatsappThemeService } from '../../services/others/whatsapp-theme.service';

@Component({
  selector: 'app-aviso-derivacion-especifica',
  standalone: true,
  host: { '[class.form-dialog--dark]': 'whatsappDarkMode()' },
  imports: [CommonModule, MatDialogModule, MatIconModule],
  templateUrl: './aviso-derivacion-especifica.component.html',
  styleUrl: './aviso-derivacion-especifica.component.scss',
})
export class AvisoDerivacionEspecificaComponent {
  whatsappDarkMode = inject(WhatsappThemeService).isDarkMode;
  readonly derivations = signal<ConversationDerivacionPopupData[]>([]);
  readonly currentIndex = signal(0);

  constructor(
    public dialogRef: MatDialogRef<AvisoDerivacionEspecificaComponent>,
    @Inject(MAT_DIALOG_DATA) data: ConversationDerivacionPopupData | ConversationDerivacionPopupData[],
  ) {
    this.dialogRef.disableClose = true;
    this.derivations.set(Array.isArray(data) ? data : [data]);
  }

  get data(): ConversationDerivacionPopupData {
    return this.derivations()[this.currentIndex()];
  }

  get totalDerivations(): number {
    return this.derivations().length;
  }

  get contactoNombre(): string {
    return (
      this.data.nombreSender ||
      'Sin nombre'
    );
  }

  previous(): void {
    this.currentIndex.update((index) => Math.max(0, index - 1));
  }

  next(): void {
    this.currentIndex.update((index) => Math.min(this.totalDerivations - 1, index + 1));
  }

  entendido(): void {
    if (this.currentIndex() < this.totalDerivations - 1) {
      this.next();
      return;
    }
    this.cerrar();
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }
}
